import {createContext, useCallback, useContext} from 'react'

export const PmAccessContext = createContext<(error: unknown) => boolean>(() => false)
export const usePmAccessFailure = () => useContext(PmAccessContext)

export function usePmProtectedRequest() {
  const handleFailure = usePmAccessFailure()
  return useCallback(async <T,>(request: () => Promise<T>): Promise<T> => {
    try {
      return await request()
    } catch (error) {
      handleFailure(error)
      throw error
    }
  }, [handleFailure])
}
